import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { Message } from "../model/message.model";
import { GridFilter, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";
import { MessageFilteredQuery } from "../model/message-filtered-query.model";
import { takeUntil } from "rxjs/operators";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";

@Component({
  selector: "ngx-message-list",
  templateUrl: "./message-list.component.html",
  styleUrls: ["./message-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageListComponent extends BaseFormComponent<Message> {
  messageFilteredQuery: MessageFilteredQuery;
  currentData: PagingDataResult<any> = new PagingDataResult<any>();
  selected: string = "";
  @ViewChild(KGridComponent) grid: KGridComponent;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "Message";
    this.areaName = "General";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Messaging.ListMessage.MessagesList");
    this.setdefault();
    this.setColumns();
    this.onClosing(undefined);
    if (
      (this.accountService.authService.currentInformation().BranchingAdvancedEnabled ||
        this.accountService.authService.currentInformation().BranchingLightEnabled ||
        this.accountService.authService.currentInformation().RestaurantCallCenter) &&
      !this.accountService.authService.currentBranch?.AccessToAllBranches
    ) {
      this.messageFilteredQuery.BranchList.push(this.accountService.authService.currentBranchId);
    }
  }
  async setColumns() {
    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.orignalColumns = data as form_control[];
          this.columns = (data as form_control[]).filter(
            (f) => ((!f.areaName || f.areaName === "default") && f.listVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.columns = this.columns.sort((a, b) => a.order - b.order);
          this.columns.forEach((x) => {
            if (x.name === "To") x.required = false;
          });
          this.setFormGroup(this.messageFilteredQuery);
        }
      });
  }

  loadData(event: GridFilter[]) {
    if (this.grid && this.grid.isRefreshing) return;
    if (this.grid) this.grid.isRefreshing = true;
    this.httpCommonService
      .create(this.apiName + "/ReadMessageList", this.messageFilteredQuery)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x: PagingDataResult<any>) => {
          this.currentData = x;
          this.cd.markForCheck();
        },
        (error) => {
          this.getFailedHelper(error);
        }
      );
  }
  setdefault() {
    if (!this.messageFilteredQuery) this.messageFilteredQuery = <MessageFilteredQuery>{};
    this.messageFilteredQuery.StatusList = [];
    this.messageFilteredQuery.TypeList = [];
    this.messageFilteredQuery.BranchList = [];
    let currentDate = new Date();
    this.messageFilteredQuery.StartTime = currentDate;
    this.messageFilteredQuery.StartTime.setDate(currentDate.getDate() - 10);
    this.messageFilteredQuery.EndTime = new Date();
  }
  addControl() {
    this.setValue("To", this.messageFilteredQuery.To);
    this.setValue("TypeList", this.messageFilteredQuery.TypeList);
    this.setValue("BranchList", this.messageFilteredQuery.BranchList);
    this.setValue("StatusList", this.messageFilteredQuery.StatusList);
    this.setValue("StartTime", this.messageFilteredQuery.StartTime);
    this.setValue("EndTime", this.messageFilteredQuery.EndTime);
    this.cd.markForCheck();
  }
  onPageChanged(event: GridFilter[]) {
    let skip: number = 0;
    let take: number = 10;
    if (!event) {
      let event1: GridFilter[] = [];
      event = event1;
    } else {
      skip = event[0]?.Skip;
      take = event[0]?.Take;
    }
    const filteredQuery = this.messageFilteredQuery;
    if (filteredQuery.To && event.some((x) => x.Filed === "To"))
      event.push({ Filed: "To", Type: "F", Value: filteredQuery.To, Operator: "contains", Logic: "and", Skip: skip, Take: take });
    if (filteredQuery.StatusList && event.some((x) => x.Filed === "StatusList"))
      event.push({ Filed: "StatusList", Type: "F", Value: filteredQuery.StatusList, Operator: "eq", Logic: "and", Skip: skip, Take: take });
    if (filteredQuery.TypeList && event.some((x) => x.Filed === "TypeList"))
      event.push({ Filed: "TypeList", Type: "F", Value: filteredQuery.TypeList, Operator: "eq", Logic: "and", Skip: skip, Take: take });
    if (filteredQuery.BranchList && event.some((x) => x.Filed === "BranchList"))
      event.push({ Filed: "BranchList", Type: "F", Value: filteredQuery.BranchList, Operator: "eq", Logic: "and", Skip: skip, Take: take });
    if (filteredQuery.StartTime && event.some((x) => x.Filed === "StartTime"))
      event.push({ Filed: "StartTime", Type: "F", Value: filteredQuery.StartTime, Operator: "gte", Logic: "and", Skip: skip, Take: take });
    if (filteredQuery.EndTime && event.some((x) => x.Filed === "EndTime"))
      event.push({ Filed: "EndTime", Type: "F", Value: filteredQuery.EndTime, Operator: "lte", Logic: "and", Skip: skip, Take: take });

    this.loadData(event);
  }
  ApplayFilter() {
    this.messageFilteredQuery.StartTime = this.formGroup.value.StartTime;
    this.messageFilteredQuery.EndTime = this.formGroup.value.EndTime;
    this.messageFilteredQuery.To = this.formGroup.value.To;
    this.messageFilteredQuery.StatusList = this.formGroup.value.StatusList;
    this.messageFilteredQuery.TypeList = this.formGroup.value.TypeList;
    this.messageFilteredQuery.BranchList = this.formGroup.value.BranchList;
    if (this.messageFilteredQuery.StatusList && this.messageFilteredQuery.StatusList.length <= 0) this.messageFilteredQuery.StatusList = null;
    if (this.messageFilteredQuery.TypeList && this.messageFilteredQuery.TypeList.length <= 0) this.messageFilteredQuery.TypeList = null;
    if (this.messageFilteredQuery.BranchList && this.messageFilteredQuery.BranchList.length <= 0) this.messageFilteredQuery.BranchList = null;
    this.onPageChanged(undefined);
  }
  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
  }
}
